export default {
  'Custom': 'カスタム',
  'Original': 'オリジナル',
}